import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withRouter from '../../Components/Common/withRouter';

// Import Components
import Header from '../Header';
import Footer from '../Footer';
import TopDockNav from './TopDockNav';
import ProfileDropdown from '../../Components/Common/ProfileDropdown';

// Import actions
import {
  changeLayoutMode,
} from '../../slices/thunks';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';

// Import SCSS
import './top-dock-layout.scss';

function TopDockLayout(props: any) {
  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );

  const { layoutModeType } = useSelector(selectLayoutProperties);

  // Layout mode change handler
  const onChangeLayoutMode = (value: any) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };

  const [headerClass, setHeaderClass] = useState<any>('');

  // Header scroll effect
  useEffect(() => {
    window.addEventListener('scroll', scrollNavigation, true);
    return () => {
      window.removeEventListener('scroll', scrollNavigation, true);
    };
  }, []);

  function scrollNavigation() {
    const scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setHeaderClass('topbar-shadow');
    } else {
      setHeaderClass('');
    }
  }

  return (
    <React.Fragment>
      <div id="layout-wrapper" className="top-dock-layout">
        <div className="top-dock-header-bar">
          <Header
            headerClass={headerClass}
            layoutModeType={layoutModeType}
            onChangeLayoutMode={onChangeLayoutMode}
          />
          <TopDockNav />
          <div className="top-dock-profile">
            <ProfileDropdown />
          </div>
        </div>
        <div className="top-dock-content">
          {props.children}
          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
}

TopDockLayout.propTypes = {
  children: PropTypes.object,
};

export default withRouter(TopDockLayout);

